import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { AccountImport, Alert, Configuration } from '../../../_models/index';
import { CustomerService, ProcessService, PayoutService } from '../../../_services/index';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { BatchFilesDetails } from 'src/app/_models/batchProcess.interface';
import { duplicateWarningMessage } from '../../../sharedcomp/utils/import-process-utils';

@Component({
  selector: 'app-old-payout-import-version',
  templateUrl: './old-payout-import-version.component.html',
  styleUrls: ['./old-payout-import-version.component.css', '../../../processes/payoutprocessimport.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class OldPayoutImportVersionComponent implements OnInit {

  customerPuplic_key: any;
  user_public_id: any;
  data: any;
  excelHeader: any;
  uploadedFileName: string;
  enableImportTxt: boolean = true;

  enableImportConfirm: boolean;
  formData: FormData = new FormData();
  searchFilterForm: FormGroup;
  enableEdit: boolean = true;
  tab1ActiveStatus: "active" | "disabled";
  tab2ActiveStatus: "active" | "disabled";
  tab3ActiveStatus: "active" | "disabled";
  tab1Visibility: boolean;
  tab2Visibility: boolean;
  tab3Visibility: boolean;
  ProcessTitle: string;
  ProcessSubTitle: string;
  processErrorDetails: string;
  customer_Account_public_id: string;
  subscriptionId: any;
  apiKey: any;
  userAuth: any = [];
  userNameProcess: any;
  userEmail: any;

  btnProx: boolean = true;
  btnRegre: boolean = false;

  resultData: any;

  totalRecords: number | string;

  parseID: any;

  configData: any;
  templateName: string = "";
  public tFileList: File;
  configuration: Configuration = [];

  publicIdCreateBatch: string;
  publicIdProcessBatch: string;
  checkResponseExportTime: any;
  timerId: any;
  isImportDataAvailable: object | undefined;
  isMassPaymentDetailAvailable: boolean = false;
  isListMassPaymentsAvailable: boolean = false;
  isErrorExportAvailable: object | undefined;

  _duplicatedFile: boolean = false;
  _idFile: string;
  _duplicatedFileWarning: boolean = false;
  _duplicatedFileError: boolean = false;
  _confirmProcess: boolean = false;
  _noInfoByError: boolean = true;
  duplicatePayoutData = {
    date: '',
    name: '',
    status: '',
    id: ''
  }
  duplicateFileData = {
    type: "",
    nameFile: "",
    dateFile: ""
  }

  alerts: Alert[] = [];
  templateOptionForm: FormControl = new FormControl('', [Validators.required]);

  constructor
    (
      private router: Router
      , private spinnerService: Ng4LoadingSpinnerService
      , private formBuilder: FormBuilder
      , private customerservice: CustomerService
      , private payoutService: PayoutService
      , private processService: ProcessService
    ) { }

  ngOnInit() {

    if (
      (localStorage.getItem('companyId') != null || localStorage.getItem('companyId') !== '' || localStorage.getItem('companyId') != undefined)
      &&
      (localStorage.getItem('application') != null || localStorage.getItem('application') !== '' || localStorage.getItem('application') != undefined)) {
      if (localStorage.getItem('isCorporate') === 'Yes') {
        this.customerPuplic_key = localStorage.getItem('subcompanyId');
      } else {
        this.customerPuplic_key = localStorage.getItem('companyId');
      }
      this.user_public_id = localStorage.getItem('userId');
      this.userNameProcess = localStorage.getItem('username');
      this.userEmail = localStorage.getItem('userEmail');
    }
    else {
      this.router.navigate(['/home']);
    }

    this.enableImportConfirm = false;
    this.getImportTemplate();
    this.searchFilterForm = this.formBuilder.group({
      edt: ['']
    });

    this.GetCustomerApiDetails();
    this.activeTab1();
    this.uploadedFileName = "Archivo a subir";
  }

  cleanAlerts() {
    this.alerts = [];
  }

  addWarningAlert(warningType: string, nameFile: string, dateFile: string) {
    const warningTypeSelected = duplicateWarningMessage(warningType, nameFile, dateFile) || duplicateWarningMessage('DEFAULT');
    this.alerts.push({
      type: 'warning',
      msg: `${warningTypeSelected}`
    });
  }

  getImportTemplate() {
    this.payoutService.getPayoutConfiguration(this.customerPuplic_key).subscribe(data => {
      this.configuration = data;
    }, error => {
      console.error('Failed! while trying to get the payout import template details. ' + error.error);
    })
  }

  importTemplate(template) {
    this.templateName = template;
  }

  GetCustomerApiDetails() {
    this.customerservice.getApiDetails(this.customerPuplic_key).subscribe(data => {
      if (data.value !== 'undefined') {
        this.apiKey = data.value;
      }
    },
      error => {
        console.error('Failed! while trying to get the acccount details list. ' + error.error);
      });
  }

  onFileChange(event: any) {
    this.spinnerService.show();
    this.processErrorDetails = "";
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length > 1) {
      throw new Error('Cannot use multiple files');
    }
    if (target.files.length === 1) {
      if (
        (target.files[0].name.includes(".txt") && (target.files[0].type === ".txt" || target.files[0].type === "text/plain")) ||
        ((target.files[0].name.includes(".xlsx") || target.files[0].name.includes(".xls")) && (target.files[0].type === ".xlsx" || target.files[0].type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type === "application/vnd.ms-excel")) ||
        (target.files[0].name.includes(".csv") && (target.files[0].type === "text/csv" || target.files[0].type === "application/vnd.ms-excel"))
      ) {
        this.enableImportTxt = false;
        this.uploadedFileName = event.target.files[0].name;
        const file = event.target.files[0];
        this.tFileList = event.target.files[0];
        this.searchFilterForm.get('edt').setValue(file);
      }
      else {
        this.enableImportTxt = true;
        this.processErrorDetails = "Please select .txt or .csv or .xls or .xlsx file only!";
      }
    }
    this.spinnerService.hide();

  }

  private set duplicatedFile(v: boolean) {
    this._duplicatedFile = v;
  }
  private get duplicatedFile(): boolean {
    return this._duplicatedFile;
  }

  private set idFileValue(v: string) {
    this._idFile = v;
  }
  private get idFileValue(): string {
    return this._idFile;
  }

  private set duplicatedFileWarning(v: boolean) {
    this._duplicatedFileWarning = v;
  }
  private get duplicatedFileWarning(): boolean {
    return this._duplicatedFileWarning;
  }

  private set duplicatedFileError(v: boolean) {
    this._duplicatedFileError = v;
  }
  private get duplicatedFileError(): boolean {
    return this._duplicatedFileError;
  }

  private set confirmProcess(v: boolean) {
    this._confirmProcess = v;
  }
  private get confirmProcess(): boolean {
    return this._confirmProcess;
  }

  private set noInfoByError(v: boolean) {
    this._noInfoByError = v;
  }
  private get noInfoByError(): boolean {
    return this._noInfoByError;
  }

  activeTab1() {
    this.btnProx = true;
    this.noInfoByError = true;
    this.enableEdit = true;
    this.duplicatedFileWarning = false;
    this.confirmProcess = false;
    this.duplicatedFileError = false;
    this.confirmProcess = false;
    this.enableImportConfirm = false;
    this.duplicateFileData = {
      type: "",
      nameFile: "",
      dateFile: ""
    }
    this.duplicatePayoutData = {
      date: '',
      name: '',
      status: '',
      id: ''
    }

    this.totalRecords = "";
    this.uploadedFileName = "";
    this.ProcessTitle = "";
    this.ProcessSubTitle = "";

    this.formData = new FormData();
    this.cleanAlerts();

    this.tab1ActiveStatus = "active";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = true;
    this.tab2Visibility = false;
    this.tab3Visibility = false;
  }

  activeTab2() {
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "active";
    this.tab3ActiveStatus = "disabled";
    this.tab1Visibility = false;
    this.tab2Visibility = true;
    this.tab3Visibility = false;
  }

  activeTab3() {
    this.tab1ActiveStatus = "disabled";
    this.tab2ActiveStatus = "disabled";
    this.tab3ActiveStatus = "active";
    this.tab1Visibility = false;
    this.tab2Visibility = false;
    this.tab3Visibility = true;
  }

  importExcelData(event, { value }: { value: AccountImport }) {
    this.spinnerService.show();
    this.enableImportTxt = true;

    const json_data: any = {
      "user": {
        "id": `${this.user_public_id}`,
        "name": `${this.userNameProcess}`,
        "email": `${this.userEmail}`
      },
      "company": {
        "id": `${this.customerPuplic_key}`,
        "name": `${this.userNameProcess}`
      }
    };

    if (value.edt.name.includes(".txt") && (value.edt.type === ".txt" || value.edt.type === "text/plain")) {
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "text/plain;charset=iso-8859-1" }), this.uploadedFileName);
    }
    else if ((value.edt.name.includes(".xlsx") || value.edt.name.includes(".xls")) && (value.edt.type === ".xlsx" || value.edt.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || value.edt.type === "application/vnd.ms-excel")) {
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "application/vnd.ms-excel" }), this.uploadedFileName);
    }
    else if (value.edt.name.includes(".csv") && (value.edt.type === "text/csv" || value.edt.type === "application/vnd.ms-excel")) {
      this.formData.append('edt', new Blob([this.searchFilterForm.get('edt').value], { type: "text/csv" }), this.uploadedFileName);
    }

    this.formData.append('description', "EDT FILE");
    this.formData.append('customer_id', this.customerPuplic_key);
    this.formData.append('template', this.templateName);
    this.formData.append('metadata', JSON.stringify(json_data))

    this.payoutService.createBatch(this.formData)
      .pipe(
        switchMap(batchResponse => {
          this.btnProx = false;
          this.resultData = batchResponse.body;

          if (batchResponse.status === 200) {
            this.publicIdCreateBatch = this.resultData.public_id;
            this.ProcessTitle = "Archivo ha sido leído correctamente";
            this.ProcessSubTitle = "Total registros leídos :";
            this.totalRecords = this.resultData.total_records;
            this.duplicatedFile = this.resultData.is_duplicate;

            if (this.duplicatedFile) {
              this.idFileValue = this.resultData.last_id;
              let batchProcessDetails = this.processService.getBatchDetails(this.idFileValue);
              return batchProcessDetails.pipe(
                catchError(error => of(['API error']))
              );
            } else {
              return of(['No Duplicate']);
            }
          } else {
            return of(['API error']);
          }
        })
      )
      .subscribe(val => {
        const batchDetailError = val as string[];
        if (batchDetailError && batchDetailError[0] === 'API error') {
          this.enableEdit = false;
          this.ProcessTitle = "";
          this.totalRecords = "";
          this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        } else {
          if (this.duplicatedFile) {
            const batchDetailResponse = val as BatchFilesDetails;
            this.duplicateFileData.type = this.resultData.is_duplicate_type
            this.duplicateFileData.nameFile = batchDetailResponse.name;
            this.duplicateFileData.dateFile = batchDetailResponse.created;
            this.addWarningAlert(this.resultData.is_duplicate_type, batchDetailResponse.name, batchDetailResponse.created);
            this.duplicatedFileWarning = true;
          }
        }
        this.activeTab2();
        this.spinnerService.hide();
      }, err => {
        this.activeTab2();
        this.enableEdit = false;
        this.btnProx = false;
        this.ProcessTitle = "";
        this.ProcessSubTitle = "Error al intentar procesar el archivo !";
        console.error('Failed! while trying to create batch ' + err);
        this.spinnerService.hide();
      });
  }

  getDuplicatePayout(batId: string) {
    this.processService.getBatchDetails(batId)
      .pipe(
        switchMap(batchResponse => {
          const metadata = JSON.parse(batchResponse.metadata);
          let batchIdTest = metadata.payout_process == undefined ? "" : metadata.payout_process.id;
          if (batchIdTest && batchIdTest !== "" && batchIdTest !== Number) {
            let payoutProcessDetails = this.payoutService.getPayoutProcessDetails(batchIdTest);
            return payoutProcessDetails.pipe(
              catchError(error => of(['API error', batchResponse]))
            );
          } else {
            return of(['API error', batchResponse])
          }
        })
      )
      .subscribe(payoutDetailResponse => {
        this.ProcessTitle = "";
        if (Array.isArray(payoutDetailResponse)) {
          const batchDetailError = payoutDetailResponse[1] as BatchFilesDetails;
          this.noInfoByError = false;
          this.ProcessSubTitle = "";
          this.duplicatePayoutData.date = batchDetailError.created;
          this.duplicatePayoutData.name = batchDetailError.name;
          this.duplicatedFileError = true;
          this.spinnerService.hide();
        } else {
          if (payoutDetailResponse.status !== 'CANCELLED') {
            this.noInfoByError = true;
            this.ProcessSubTitle = "";
            this.duplicatePayoutData.date = payoutDetailResponse.created;
            this.duplicatePayoutData.name = payoutDetailResponse.name;
            this.duplicatePayoutData.status = payoutDetailResponse.status;
            this.duplicatePayoutData.id = payoutDetailResponse.public_id;
            this.duplicatedFileError = true;
            this.spinnerService.hide();
          }
        }
      });
  }

  importConfirm() {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.ProcessTitle = "";
    this.ProcessSubTitle = "";
    this.isImportDataAvailable = null;
    this.isErrorExportAvailable = null;
    this.enableImportConfirm = true;
    this.activeTab3();

    let i = 0;
    this.checkResponseExportTime = () => {
      this.timerId = setTimeout(() => {
        i++;
        if (i >= 10 && this.isErrorExportAvailable === null) {
          clearTimeout(this.timerId);
          this.ProcessTitle = "El archivo está siendo procesado ...";
          this.isListMassPaymentsAvailable = true;
          this.spinnerService.hide();
        } else {
          if (this.isImportDataAvailable !== null) {
            clearTimeout(this.timerId);
            this.ProcessTitle = "El archivo fue procesado correctamente ...";
            this.isMassPaymentDetailAvailable = true;
            this.spinnerService.hide();
          } else {
            this.checkResponseExportTime();
          }
        }
      }, 1000)
    };
    this.checkResponseExportTime();

    this.payoutService.processBatch(this.publicIdCreateBatch).subscribe(val => {
      this.isImportDataAvailable = val;
      this.publicIdProcessBatch = val.public_id;
      this.publicIdCreateBatch = '';
      this.confirmProcess = true;
      this.spinnerService.hide();
    }, err => {
      this.isErrorExportAvailable = err.error;
      clearTimeout(this.timerId);
      if (this.isListMassPaymentsAvailable !== true) {
        this.enableEdit = false;
        if (this.isErrorExportAvailable['code'] && err.status === 400) {
          this.ProcessSubTitle = this.isErrorExportAvailable['description'] || "Error al intentar procesar el archivo !";
          this.getDuplicatePayout(this.idFileValue);
        } else {
          this.ProcessSubTitle = "Error al intentar procesar el archivo !";
          this.confirmProcess = true;
        }
      }
    });
  }

}
